__webpack_require__.p = "/assets/turbo/d66a23f7/quellede/_next/";